export interface WaterQuality {
  logId: number;
  globalSiteId: string;
  date: string;
  createdBy: string;
  cycles: WaterQualityCycle[];
}

export interface WaterQualityCycle {
  cycleName: string;
  pondName: string;
  zoneId: string;
  zoneName: string;
  pondId: string;
  cycleId: number;
  waterQualityTypeId: number;
  value: number;
  amPm: AmPm;
  previousMw: number;
  previousQty: number;
}

export enum AmPm {
  AM = 'am',
  PM = 'pm',
}
